<div
  class="jt-datepicker-container"
  [attr.title]="tooltipText || (accessiblePlaceholder | translate)">
  <input
    #dateInput
    #dp="bsDatepicker"
    type="text"
    class="form-control"
    [attr.data-testid]="testId"
    [placeholder]="(placeholder || 'Messages.SelectDate') | translate"
    [attr.aria-label]="accessiblePlaceholder | translate"
    bsDatepicker
    [bsConfig]="bsConfig"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [disabled]="formControlDisabled || isDisabled"
    [(bsValue)]="selectedDate"
    (bsValueChange)="onDateSelected($event)"
    readonly />
  <button
    type="button"
    class="jt-datepicker-icon"
    [disabled]="formControlDisabled || isDisabled"
    [attr.aria-label]="accessiblePlaceholder | translate"
    (click)="dp.toggle()">
    <app-svg-icon [type]="'calendar'" [className]="'jt-datepicker-calendar-icon'"></app-svg-icon>
  </button>
</div>
